<h3 mat-dialog-title>Bemerkung für ausgewählte Tiere</h3>

<mat-dialog-content>
    <mat-form-field style="width: 100%">
        <mat-label>Bemerkung</mat-label>
        <textarea matInput [formControl]="textCtrl" rows="3"></textarea>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions style="display: flex; justify-content: space-between; width: 100%">
    <button mat-flat-button color="primary" (click)="save()">Speichern</button>
    <button mat-button color="primary" (click)="this.dialogRef.close()">Abbrechen</button>
</mat-dialog-actions>
